enum SCHEDULE_TYPES {
  ACTIVE = 'ACTIVE',
  SHARED = 'SHARED',
  WIP = 'WIP',
  DELETED = 'DELETED', 
  DELETED_WIP = "DELETED_WIP",
}

export default SCHEDULE_TYPES;



// WEBPACK FOOTER //
// ./src/constants/scheduleTypes.ts